import { request } from './axios.js'
export let addIcaurRentCarApi = (data) =>
  request({ data, url: '/webapp/api/icaurRentCar/add', })


export let icaurRentCarUserInfoApi = (data) =>
  request({ data, url: '/webapp/api/icaurRentCar/userInfo'})


export let timePeriodListApi = (data) =>
  request({ data, url: '/webapp/api/icaurRentCar/timePeriodList'})